import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Layout/Header";
import Footer from "./components/Layout/Footer";
import LanguageNotification from "./components/LanguageNotification";
import BackToTop from "./components/BackToTop";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import FindFood from "./pages/FindFood";
import Donate from "./pages/Donate";
import Community from "./pages/Community";
import Impact from "./pages/Impact";
import Auth from "./pages/Auth";
import DonorDashboard from "./pages/DonorDashboard";
import RecipientDashboard from "./pages/RecipientDashboard";
import VolunteerDashboard from "./pages/VolunteerDashboard";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Profile from "./pages/Profile";
import HelpCenter from "./pages/HelpCenter";
import FoodSafety from "./pages/FoodSafety";
import Guidelines from "./pages/Guidelines";
import ContactUs from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import About from "./pages/About";
import Partnership from "./pages/Partnership";
import SuccessStories from "./pages/SuccessStories";
import TawkToChat from "./components/TawkToChat";
// import ChatSupport from "./components/ChatSupport";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <LanguageProvider>
          <ScrollToTop />
          <div className="flex flex-col min-h-screen">
            <Header />
            <main className="flex-1">
              <Routes>
                {/* English routes (default) */}
                <Route path="/" element={<Home />} />
                <Route path="/find-food" element={<FindFood />} />
                <Route path="/donate" element={<Donate />} />
                <Route path="/community" element={<Community />} />
                <Route path="/impact" element={<Impact />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/dashboard/donor" element={<DonorDashboard />} />
                <Route
                  path="/dashboard/recipient"
                  element={<RecipientDashboard />}
                />
                <Route
                  path="/dashboard/volunteer"
                  element={<VolunteerDashboard />}
                />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/help" element={<HelpCenter />} />
                <Route path="/safety" element={<FoodSafety />} />
                <Route path="/guidelines" element={<Guidelines />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/about" element={<About />} />
                <Route path="/partnership" element={<Partnership />} />
                <Route path="/success-stories" element={<SuccessStories />} />

                {/* Sinhala routes */}
                <Route path="/si" element={<Home />} />
                <Route path="/si/find-food" element={<FindFood />} />
                <Route path="/si/donate" element={<Donate />} />
                <Route path="/si/community" element={<Community />} />
                <Route path="/si/impact" element={<Impact />} />
                <Route path="/si/auth" element={<Auth />} />
                <Route
                  path="/si/dashboard/donor"
                  element={<DonorDashboard />}
                />
                <Route
                  path="/si/dashboard/recipient"
                  element={<RecipientDashboard />}
                />
                <Route
                  path="/si/dashboard/volunteer"
                  element={<VolunteerDashboard />}
                />
                <Route
                  path="/si/forgot-password"
                  element={<ForgotPassword />}
                />
                <Route path="/si/reset-password" element={<ResetPassword />} />
                <Route path="/si/profile" element={<Profile />} />
                <Route path="/si/help" element={<HelpCenter />} />
                <Route path="/si/safety" element={<FoodSafety />} />
                <Route path="/si/guidelines" element={<Guidelines />} />
                <Route path="/si/contact" element={<ContactUs />} />
                <Route path="/si/privacy" element={<PrivacyPolicy />} />
                <Route path="/si/terms" element={<TermsOfService />} />
                <Route path="/si/about" element={<About />} />
                <Route path="/si/partnership" element={<Partnership />} />
                <Route
                  path="/si/success-stories"
                  element={<SuccessStories />}
                />

                {/* Tamil routes */}
                <Route path="/ta" element={<Home />} />
                <Route path="/ta/find-food" element={<FindFood />} />
                <Route path="/ta/donate" element={<Donate />} />
                <Route path="/ta/community" element={<Community />} />
                <Route path="/ta/impact" element={<Impact />} />
                <Route path="/ta/auth" element={<Auth />} />
                <Route
                  path="/ta/dashboard/donor"
                  element={<DonorDashboard />}
                />
                <Route
                  path="/ta/dashboard/recipient"
                  element={<RecipientDashboard />}
                />
                <Route
                  path="/ta/dashboard/volunteer"
                  element={<VolunteerDashboard />}
                />
                <Route
                  path="/ta/forgot-password"
                  element={<ForgotPassword />}
                />
                <Route path="/ta/reset-password" element={<ResetPassword />} />
                <Route path="/ta/profile" element={<Profile />} />
                <Route path="/ta/help" element={<HelpCenter />} />
                <Route path="/ta/safety" element={<FoodSafety />} />
                <Route path="/ta/guidelines" element={<Guidelines />} />
                <Route path="/ta/contact" element={<ContactUs />} />
                <Route path="/ta/privacy" element={<PrivacyPolicy />} />
                <Route path="/ta/terms" element={<TermsOfService />} />
                <Route path="/ta/about" element={<About />} />
                <Route path="/ta/partnership" element={<Partnership />} />
                <Route
                  path="/ta/success-stories"
                  element={<SuccessStories />}
                />
              </Routes>
            </main>
            <Footer />
            <LanguageNotification />
            <BackToTop />
            <TawkToChat />
          </div>
        </LanguageProvider>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
